//base Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, EventEmitter, ViewChild } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//routing
import { Routes, RouterModule, RouterLink} from '@angular/router';
import { AppRouting } from './app-routing.module';
import { routerTransition, chartTransition } from './_animations/inout.animation';

//src pages
import { AppComponent } from './app.component';
import { Hplc1Component } from './hplc1/hplc1.component';
import { Hplc2Component } from './hplc2/hplc2.component';
import { Hplc3Component } from './hplc3/hplc3.component';
import { HplcselectComponent } from './hplcselect/hplcselect.component';
import { HPLCSelectDialog, IntroComponent } from './intro/intro.component';
import { View1Component } from './view1/view1.component';
import { Chart1Component } from './chart1/chart1.component';
import { Chart2Component } from './chart2/chart2.component';
import { Chart3Component } from './chart3/chart3.component';
import { ParametersComponent } from './parameters/parameters.component';
// import { ThreeComponent } from './three/three.component';

//components
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { ChartModule } from 'angular2-chartjs';
import { ConstructionComponent } from './construction/construction.component';
import { KeypadComponent } from './keypad/keypad.component';
import { View2Component } from './view2/view2.component';
import { InfodialogComponent } from './infodialog/infodialog.component';
import { GifdialogComponent } from './gifdialog/gifdialog.component';
// import { SuperGif } from '@wizpanda/super-gif';

@NgModule({
  declarations: [
    AppComponent,
    HplcselectComponent,
    Hplc1Component,
    Hplc2Component,
    Hplc3Component,
    IntroComponent,
    View1Component,
    ConstructionComponent,
    HPLCSelectDialog,
    KeypadComponent,
    View2Component,
    Chart1Component,
    Chart2Component,
    Chart3Component,
    ParametersComponent,
    // ThreeComponent,
    InfodialogComponent,
    GifdialogComponent,
    // SuperGif
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    AppRouting,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatGridListModule,
    MatSelectModule,
    MatInputModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatStepperModule,
    ChartModule,
    MatTabsModule,
    MatRadioModule,
    MatCheckboxModule,
    MatCardModule,
    MatSliderModule,
    MatTableModule,
    MatDialogModule
  ],
   entryComponents: [HPLCSelectDialog, KeypadComponent, InfodialogComponent, GifdialogComponent],
  exports: [
  //   MatMenuTrigger,
    // RouterModule
  ],
  providers: [
],
  bootstrap: [AppComponent]
})
export class AppModule {
  title = 'HPLC Simulator';
}
// platformBrowserDynamic().bootstrapModule(AppModule);
